<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4">
  <vw-header-home [user]="user"></vw-header-home>
  <div class="pb-6 w-full">
    <div class="flex flex-col gap-2">
      <!-- Wait for user to be loaded to be sure that address-uid is set to localstorage -->
      @if (userLoaded) {
      <vw-garden-today-card [advice]="advice"></vw-garden-today-card>
      }
      @if (!userLoaded) {
      <vw-skeleton-loader [width]="'100%'" [height]="'50px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
      }
      @if (userLoaded) {
        <vw-alerts-banner (bannerClick)="onNotificationsClicked()"></vw-alerts-banner>
      }
    </div>
  </div>

  <!-- « Aujourd'hui dans ton potager » : conseils du jour et recoltes mures.
       Le bloc s'affiche des qu'il a une seule chose a dire — une recolte sans
       conseil reste une raison de sortir. -->
  @if (advice && (advice.advices.length > 0 || advice.harvestSuggestions?.length > 0)) {
  <div class="pb-6 w-full flex flex-col gap-2">
    <vw-garden-advices-widget [advice]="advice"></vw-garden-advices-widget>
    <!-- Juste sous les conseils : l'utilisateur vient de constater ce que
         l'app sait faire, c'est le seul moment où l'offre a du sens. -->
    @if (showTeasers) {
    <vw-premium-teaser
      [message]="'premium.teaser.lunar' | translate"
      [detail]="'premium.teaser.lunar-detail' | translate"
      source="home_advices"
      (ctaClicked)="openPaywall($event)"
    ></vw-premium-teaser>
    }
  </div>
  }

  <div class="pb-2 w-full">
    @if (hierarchies?.length === 0 && !isLoading) {
    <div class="flex flex-col gap-2">
      <h2 class="text-primary-title text-2xl font-semibold">
        {{ "home.cultivations.empty-title" | translate }}
      </h2>
      <p class="text-grey-600">{{ "home.cultivations.empty" | translate }}</p>
      <div class=" w-full flex flex-col gap-4 items-center">
        <vw-icon-svg [iconUrl]="'assets/images/plant/empty-hierarchies.png'" width="50%"
          class="flex justify-center"></vw-icon-svg>
        <vw-button [label]="'home.cultivations.addPlant'" (click)="onAddPlant()">
        </vw-button>
      </div>
    </div>
    }
    <!-- Les plantes que la journee concerne, en images. Elle remplace la
         grille de TOUTES les cultures, qui faisait de l'accueil une seconde
         version du Potager — lequel reste a un geste, via « Tout voir ». -->
    @if (hierarchies?.length > 0 && !isLoading) {
      <vw-plants-attention-carousel [advice]="advice"></vw-plants-attention-carousel>
    }

    <!-- GDD milestones (in-progress plants) -->
    @if (gddMilestones.length > 0) {
    <div class="mt-8 flex flex-col gap-2">
      <vw-gdd-milestones-widget [items]="gddMilestones" [maxItems]="gddMaxItems"></vw-gdd-milestones-widget>
      <!-- La progression est visible, la date de récolte ne l'est pas :
           l'encart répond à la question que l'écran vient de poser. -->
      @if (showTeasers) {
      <vw-premium-teaser
        [message]="'premium.teaser.harvest' | translate"
        [detail]="'premium.teaser.harvest-detail' | translate"
        source="home_gdd"
        (ctaClicked)="openPaywall($event)"
      ></vw-premium-teaser>
      }
    </div>
    }

    <!-- Conseils du moment : trois, pas vingt. Le contenu editorial reste
         present sans monopoliser la page. -->
    @if (articles?.length > 0) {
    <div class="flex flex-col gap-4 mt-8">
      <div class="flex items-baseline justify-between gap-3">
        <h2 class="text-primary-title text-2xl font-semibold">
          {{ "home.articles.title" | translate }}
        </h2>
        <button type="button" (click)="onAllArticles()"
          class="shrink-0 text-sm font-semibold text-primary">
          {{ 'articles.see-all' | translate }} &rsaquo;
        </button>
      </div>
      <!-- Deux par rangee : la banniere pleine largeur prenait la hauteur de
           trois blocs utiles pour trois articles. -->
      <!-- Defilement horizontal, comme les plantes : une grille faisait
           repasser le troisieme article a la ligne et doublait la hauteur de
           la section pour un article de plus. -->
      <div class="-mx-4 flex snap-x snap-mandatory scroll-pl-4 scroll-pr-4 gap-3 overflow-x-auto px-4 pb-1">
        @for (article of articles; track article) {
        <div class="w-[172px] shrink-0 snap-start">
          <vw-article [article]="article" [compact]="true"></vw-article>
        </div>
        }
      </div>
    </div>
    }
    <!-- L'avis en pied de page : c'est une faveur qu'on demande, elle ne passe
         pas devant le jardin. -->
    <div class="mt-8 mb-28">
      <div [style.background-color]="'#9AD6AD' | HexToHsl" (click)="onFeedbackClicked()"
        class="shadow-lg rounded-xl w-full relative overflow-hidden h-12 flex items-center justify-between cursor-pointer">
        <vw-chevron-right-icon
          class="transition-transform duration-300 absolute right-3 top-1/2 -translate-y-1/2 text-[#093935]" />
        <div class="h-full flex items-center px-4 gap-2">
          <div class="w-8 flex items-center justify-center shrink-0 h-5">
            <vw-message-circle-question-icon class="text-[#093935] h-5" />
          </div>
          <p class="text-sm font-medium whitespace-normal text-[#093935]">
            {{ 'home.feedback.title' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

</div>

<vw-feedback-modal [isOpen]="isFeedbackModalOpen" (onModalClosed)="isFeedbackModalOpen = false"></vw-feedback-modal>

<vw-premium-toast
  [isOpen]="premiumPaywallMode"
  [source]="paywallSource"
  (close)="premiumPaywallMode = false"
></vw-premium-toast>
<!-- <vw-report-modal [isOpen]="true"></vw-report-modal> -->